<template>
  <v-container>
    <v-card class="mb-3">
      <v-card-title primary-title class="mb-2">
        <div>
          <h2 class="display-1 mb-3">{{ addon.id }}</h2>
          <div class="subheading">{{ addon.description.short }}</div>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-avatar size="40px">
          <img :src="addon.author.photo"/>
        </v-avatar>
        <!--<p>{{ addon.author.email }}</p>-->
        <div class="title">{{ addon.author.username }}</div>

        <v-spacer/>

        <v-btn color="error">{{ addon.type }}</v-btn>
        <v-btn color="info">{{ addon.version }}</v-btn>

        <v-spacer/>

        <v-btn icon class="pr-4">
          <v-icon>favorite</v-icon>
          <span class="pl-1">{{ addon.favorites ? addon.favorites : 0 }}</span>
        </v-btn>

        <v-btn icon class="pr-2">
          <v-icon>file_download</v-icon>
          <span class="pl-1">{{ addon.dl_count ? addon.dl_count : 0 }}</span>
        </v-btn>

        <v-btn icon>
          <v-icon>share</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-card-title>
        <div>
          <h3 class="display-3">{{ addon.name }}</h3>
          <vue-markdown class="title markdown">{{ addon.description.long }}</vue-markdown>
        </div>
      </v-card-title>
    </v-card>

    <v-speed-dial fab fixed bottom right direction="top">
      <v-btn slot="activator" color="blue darken-2" dark fab @click="download">
        <!--:href="addon.archive" :download="`${addon.id}.zip`" >-->
        <v-progress-circular v-if="isDownloading" indeterminate color="white"/>
        <v-icon v-else>file_download</v-icon>
      </v-btn>
      <!--      <v-tooltip left transition="scale-transition">
			  <v-btn slot="activator" fab dark small color="red">
				<v-icon>report</v-icon>
			  </v-btn>
			  <span>Report plugin</span>
			</v-tooltip>
			<v-tooltip left transition="scale-transition">
			  <v-btn slot="activator" fab dark small color="green">
				<v-icon>thumb_up</v-icon>
			  </v-btn>
			  <span>Mark as correct</span>
			</v-tooltip>-->
    </v-speed-dial>
    <BackButton class="back-button" to="/" color="primary" text="Back to Home"/>
  </v-container>
</template>

<script>
  import BackButton from '../BackButton';
  import { db, storage } from '../../firebase';
  import VueMarkdown from 'vue-markdown';

  export default {
    name: 'Addon',
    components: {
      BackButton,
      VueMarkdown
    },
    data () {
      return {
        isDownloading: false
      };
    },
    firebase () {
      return {
        addon: {
          source: db.ref('addons').child(this.$route.params.id),
          asObject: true
        }
      };
    },
    methods: {
      downloadBlob (blob) {
        let newBlob = new Blob([ blob ], {type: 'application/zip'});

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }

        const data = window.URL.createObjectURL(newBlob);
        let link = document.createElement('a');
        link.href = data;
        link.download = `${this.addon.id}.zip`;
        link.click();
        this.isDownloading = false;
        setTimeout(() => {
          window.URL.revokeObjectURL(data);
        }, 100);
      },
      download () {
        this.isDownloading = true;
        fetch(this.addon.archive, {})
          .then(r => r.blob())
          .then(this.downloadBlob);
      }
    }
  };
</script>

<style scoped>

  .back-button {
    bottom: 64px !important;
    z-index: 4;
    position: absolute;
  }

  .markdown {
    font-weight: normal;
  }

</style>



// WEBPACK FOOTER //
// src/components/Addon/Addon.vue